import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'profile.layout.tabTitle',
		defaultMessage: 'Profile',
		description: 'The title for the user profile page',
	},
	myStats: {
		id: 'profile.header.myStats',
		defaultMessage: 'My Stats',
		description: "A link to the user's statistics on app usage",
	},
	manageDependents: {
		id: 'profile.header.manageDependents',
		defaultMessage: 'Manage Dependents',
		description: "A link to the user's dependents that have access to their Calm subscription",
	},
	myLanguage: {
		id: 'profile.header.myLanguage',
		defaultMessage: 'Language',
		description: 'A page title for a user to change language preferences',
	},
	myAccountSettings: {
		id: 'profile.header.myAccountSettings',
		defaultMessage: 'Account Settings',
		description: 'A page title for the user to change account settings',
	},
	myAccountDetails: {
		id: 'profile.header.myAccountDetails',
		defaultMessage: 'Account Details',
		description: 'A page title for the user to change account details',
	},
	changePassword: {
		id: 'profile.header.changePassword',
		defaultMessage: 'Change Password',
		description: 'A page title for the user to update their account password',
	},
	subscribe: {
		id: 'profile.header.subscribe',
		defaultMessage: 'Subscribe',
		description: 'A page title for a non-subscribed user to subscribe',
	},
	mySubscription: {
		id: 'profile.header.mySubscription',
		defaultMessage: 'Manage Subscription',
		description: "A button that leads to a user's subscription details",
	},
	terms: {
		id: 'profile.header.terms',
		defaultMessage: 'Terms',
		description: 'A link to terms of service',
	},
	support: {
		id: 'profile.header.support',
		defaultMessage: 'Support',
		description: 'A link to our support page',
	},
	faq: {
		id: 'profile.header.faq',
		defaultMessage: 'FAQ',
		description: 'A link to frequently asked questions',
	},
	logout: {
		id: 'profile.header.logout',
		defaultMessage: 'Log out',
		description: 'A logout button',
	},
	loggedInAs: {
		id: 'profile.loggedInAs',
		defaultMessage: 'Logged in as: {email}',
		description: 'Displays which user is logged in',
	},
});
